import { render, staticRenderFns } from "./kng-form-single.vue?vue&type=template&id=4e92991d"
import script from "./kng-form-single.vue?vue&type=script&lang=js"
export * from "./kng-form-single.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports